import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	Box,
	Drawer,
	Hidden,
	List,
	makeStyles
} from '@material-ui/core';
import { List as ListIcon } from 'react-feather';

import {useTranslation} from "react-i18next";
import NavItem from './NavItem';
import {isAdmin} from '../../../security/SecurityService';

const useStyles = makeStyles(() => ({
	mobileDrawer: {
		width: 256
	},
	desktopDrawer: {
		width: 256,
		top: 64,
		height: 'calc(100% - 64px)'
	}
}));

const NavBar = ({ onMobileClose, openMobile }) => {
	const classes = useStyles();
	const location = useLocation();

	useEffect(() => {
		if (openMobile && onMobileClose) {
			onMobileClose();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);
	const { t } = useTranslation();

	const items = [];

    items.push({
        href: '/app/fines',
        icon: ListIcon,
        title: t('FINES')
    });
    items.push({
        href: '/app/parking-events',
        icon: ListIcon,
        title: t('PARKING_EVENTS')
    });
    items.push({
        href: '/app/parking-permits',
        icon: ListIcon,
        title: t('PARKING_PERMITS')
    });

    if (isAdmin()) {
        items.push({
            href: '/app/parking-zones',
            icon: ListIcon,
            title: t('PARKING_ZONES')
        });
        items.push({
            href: '/app/parking-zone-groups',
            icon: ListIcon,
            title: t('PARKING_ZONE_GROUPS')
        });
        items.push({
            href: '/app/users',
            icon: ListIcon,
            title: t('USERS')
        });
        items.push({
            href: '/app/verification-status',
            icon: ListIcon,
            title: t('VERIFICATION_STATUS')
        });
		items.push({
			href: '/app/settings',
			icon: ListIcon,
			title: t('SETTINGS')
		});
    }

	const content = (
		<Box
			height="100%"
			display="flex"
			flexDirection="column"
		>
			<Box p={2}>
				<List>
					{items.map((item) => (
						<NavItem
							href={item.href}
							key={item.title}
							title={item.title}
							icon={item.icon}
						/>
					))}
				</List>
			</Box>
			<Box flexGrow={1} />
		</Box>
	);

	return (
		<>
			<Hidden lgUp>
				<Drawer
					anchor="left"
					classes={{ paper: classes.mobileDrawer }}
					onClose={onMobileClose}
					open={openMobile}
					variant="temporary"
				>
					{content}
				</Drawer>
			</Hidden>
			<Hidden mdDown>
				<Drawer
					anchor="left"
					classes={{ paper: classes.desktopDrawer }}
					open
					variant="persistent"
				>
					{content}
				</Drawer>
			</Hidden>
		</>
	);
};

NavBar.propTypes = {
	onMobileClose: PropTypes.func,
	openMobile: PropTypes.bool
};

NavBar.defaultProps = {
	onMobileClose: () => {},
	openMobile: false
};

export default NavBar;
